module.exports = __webpack_public_path__ + "img/pin_substitution_blue.adbdb2c8.svg";